export default __webpack_public_path__ + "static/media/gate_driver.b4595af0.svg";